<template>
  <v-card class="mt-10 mb-5" outlined>
    <v-card-text class="pa-10">
      <h2 class="text-h6 font-weight-medium text-left pb-5">
        {{ $t("string684") }}
      </h2>
      <v-alert dense outlined type="error" v-if="error">
        <ul>
          <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
        </ul>
      </v-alert>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12">
            <div class="subtitle-2">
              {{ $t("string686") }}
            </div>
            <v-radio-group
              :rules="reqRules"
              v-model="data.qus1"
              row
              hide-details="auto"
            >
              <v-radio :label="$t('Yes')" value="true"></v-radio>
              <v-radio :label="$t('No')" value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <div class="subtitle-2">
              {{ $t("string687") }}
            </div>
            <v-radio-group
              :rules="reqRules"
              v-model="data.qus2"
              row
              hide-details="auto"
            >
              <v-radio :label="$t('Yes')" value="true"></v-radio>
              <v-radio :label="$t('No')" value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <div class="subtitle-2 pb-3">
              {{ $t("string685") }}
            </div>
            <v-textarea
              dense
              outlined
              v-model="data.comments"
              :label="$t('RM2')"
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn color="light-blue" dark @click="addReview">
              {{ $t("SubmitReview") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import PartnerService from "@/services/PartnerService";
import swal from "sweetalert";

export default {
  name: "AboutMemberComponent",
  components: {},
  props: ["data"],
  data() {
    return {
      valid: false,
      error: null,
      reqRules: [value => !!value || this.$t("string719")]
    };
  },
  methods: {
    async addReview() {
      await this.$refs.form.validate();
      if (this.valid) {
        PartnerService.addReview(this.data)
          .then(() => {
            swal({
              icon: "success",
              text: this.$t("stringN609"),
              button: {
                text: this.$t("Close"),
                className: "swal-close"
              }
            }).then(() => {
              this.$router.push({ name: "Dashboard" });
            });
          })
          .catch(err => {
            this.error = err.response.data.errors;
          });
      }
    }
  }
};
</script>

<style></style>
